import {useTranslation} from "react-i18next";
import Form from "react-bootstrap/Form";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import {INTERVAL_TYPES} from "core/devices";
import RowTRComponentInput from "../../../components/RowTRComponentInput";
import ConditionalRender from "components/ConditionalRender";

const shipModel = {
    id: "",
    name: "",
    model: "",
    interval_type: "",
    values: {
        h_start: "10",
        min_measure: "60",
        num_pub: "6",
        num_measures: "1",
        min_measure_b: "2",
        interval_send: "1",
    },
};

const ManagerShipsForm = ({item = {...shipModel}, intervalType = "", onIntervalTypeChange, onFieldChange}) => {
    const {t} = useTranslation("forms");
    const {t: tC} = useCustomTranslation(translations);
    const {t: tChoices} = useTranslation("choices");

    // Get allowed fields for current interval type
    const allowedFields = INTERVAL_TYPES.values[intervalType] || [];

    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-striped mb-5">
                    <thead>
                        <tr>
                            <th className="align-middle">{t("common.name")}</th>
                            <th className="align-middle">{t("common.description")}</th>
                            <th className="align-middle text-center">
                                <small className="">{tC("parameters") !== "parameters" ? tC("parameters") : "Parámetros"}</small>
                            </th>
                            <th style={{width: "0", textAlign: "center"}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="align-middle">
                                {tC("field.interval_type") !== "field.interval_type"
                                    ? tC("field.interval_type")
                                    : "Tipo de intervalo"}
                            </td>
                            <td className="align-middle">
                                {tC("field.interval_type.description") !== "field.interval_type.description"
                                    ? tC("field.interval_type.description")
                                    : "-"}
                            </td>
                            <td className="align-middle">
                                <div className="d-flex justify-content-end align-items-center">
                                    <label htmlFor="interval_type" className="form-label me-2 mb-0">
                                        {tC("field.interval_type.params") !== "field.interval_type.params"
                                            ? tC("field.interval_type.params")
                                            : "Tipo"}
                                    </label>
                                    <Form.Select
                                        id="interval_type"
                                        name="interval_type"
                                        value={intervalType}
                                        onChange={onIntervalTypeChange}
                                        className="form-select"
                                        style={{maxWidth: "120px"}}
                                        aria-label={tC("field.interval_type")}>
                                        <option value="">{tC("field.select")}</option>
                                        {INTERVAL_TYPES.choices().map((type, index) => (
                                            <option key={index} value={type}>
                                                {tChoices("interval_type." + type)}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </td>
                            <td className="align-middle text-center"></td>
                        </tr>

                        <ConditionalRender condition={allowedFields.includes("h_start")}>
                            <RowTRComponentInput
                                fieldName="h_start"
                                fieldText="field.start_hour"
                                _TC={tC}
                                valueIn={item.values.h_start}
                                type="number"
                                inputProps={{
                                    min: 0,
                                    max: 1440,
                                    step: 1,
                                }}
                                onChangeExternal={onFieldChange}
                            />
                        </ConditionalRender>
                        <ConditionalRender condition={allowedFields.includes("num_pub")}>
                            <RowTRComponentInput
                                fieldName="num_pub"
                                fieldText="field.number_to_send"
                                _TC={tC}
                                valueIn={item.values.num_pub}
                                type="number"
                                inputProps={{
                                    min: 1,
                                    max: 1440,
                                    step: 1,
                                }}
                                onChangeExternal={onFieldChange}
                            />
                        </ConditionalRender>
                        <ConditionalRender condition={allowedFields.includes("min_measure")}>
                            <RowTRComponentInput
                                fieldName="min_measure"
                                fieldText="field.minutes_between_measures"
                                _TC={tC}
                                valueIn={item.values.min_measure}
                                type="number"
                                inputProps={{
                                    min: 2,
                                    max: 1440,
                                    step: 1,
                                }}
                                onChangeExternal={onFieldChange}
                            />
                        </ConditionalRender>
                        <ConditionalRender condition={allowedFields.includes("num_measures")}>
                            <RowTRComponentInput
                                fieldName="num_measure"
                                fieldText="field.collected_measures"
                                _TC={tC}
                                valueIn={item.values.num_measure}
                                type="number"
                                inputProps={{
                                    min: 1,
                                    max: 12,
                                    step: 1,
                                }}
                                onChangeExternal={onFieldChange}
                            />
                        </ConditionalRender>
                        <ConditionalRender condition={allowedFields.includes("min_measure_b")}>
                            <RowTRComponentInput
                                fieldName="min_measure_b"
                                fieldText="field.minutes_between_measures_fl"
                                _TC={tC}
                                valueIn={item.values.min_measure_b}
                                type="number"
                                inputProps={{
                                    min: 2,
                                    max: 1440,
                                    step: 1,
                                }}
                                onChangeExternal={onFieldChange}
                            />
                        </ConditionalRender>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ManagerShipsForm;
